/**
 * @generated SignedSource<<851de71f3581dcdb729f408c1114c222>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "anonymous"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentableId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v3 = [
  {
    "kind": "Variable",
    "name": "anonymous",
    "variableName": "anonymous"
  },
  {
    "kind": "Variable",
    "name": "commentableId",
    "variableName": "commentableId"
  },
  {
    "kind": "Variable",
    "name": "content",
    "variableName": "content"
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "success",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "needsAuthentication",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ValidationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "field",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messages",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MutationResult",
  "abstractKey": "__isMutationResult"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "CommentCard_comment"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFromAdminUser",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsCount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiresModeration",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submitComment",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsDisplayAuthorized",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesDisplayAuthorized",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesSubmissionAuthorized",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalizeUrl",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCommentsCount",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v15/*: any*/),
    (v5/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatarUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAdmin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "additionalViewerFields",
          "storageKey": null
        }
      ],
      "type": "Viewer",
      "abstractKey": "__isViewer"
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "CommentAuthorizations",
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v25 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesDownAuthorized",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submitVote",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesMode",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "up",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "down",
  "storageKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "unauthorizedMessages",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v27/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentViewerVote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "singleVoteMode",
      "storageKey": null
    },
    (v28/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Votes",
      "kind": "LinkedField",
      "name": "votes",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v29/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingVotesCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "limitedVotesPerUser",
      "storageKey": null
    }
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
},
v32 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isReportable"
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/),
    (v28/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v26/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Votes",
      "kind": "LinkedField",
      "name": "votes",
      "plural": false,
      "selections": [
        (v29/*: any*/),
        (v30/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Reactable",
  "abstractKey": "__isReactable"
},
v34 = {
  "alias": null,
  "args": (v25/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "CommentsPanel_comments",
  "kind": "LinkedHandle",
  "name": "comments"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubmitCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SubmitCommentPayload",
        "kind": "LinkedField",
        "name": "submitComment",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CommentEdge",
            "kind": "LinkedField",
            "name": "newCommentEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": "comments",
                    "args": null,
                    "concreteType": "CommentConnection",
                    "kind": "LinkedField",
                    "name": "__CommentsPanel_comments_connection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": "comments",
                                "args": null,
                                "concreteType": "CommentConnection",
                                "kind": "LinkedField",
                                "name": "__CommentsPanel_comments_connection",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v7/*: any*/),
                                          {
                                            "alias": "comments",
                                            "args": null,
                                            "concreteType": "CommentConnection",
                                            "kind": "LinkedField",
                                            "name": "__CommentsPanel_comments_connection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CommentEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v5/*: any*/),
                                                      (v7/*: any*/),
                                                      {
                                                        "alias": "comments",
                                                        "args": null,
                                                        "concreteType": "CommentConnection",
                                                        "kind": "LinkedField",
                                                        "name": "__CommentsPanel_comments_connection",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Comment",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v5/*: any*/),
                                                                  (v7/*: any*/),
                                                                  {
                                                                    "alias": "comments",
                                                                    "args": null,
                                                                    "concreteType": "CommentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "__CommentsPanel_comments_connection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "CommentEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                          {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Comment",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v5/*: any*/),
                                                                              (v7/*: any*/),
                                                                              {
                                                                                "alias": "comments",
                                                                                "args": null,
                                                                                "concreteType": "CommentConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "__CommentsPanel_comments_connection",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                      {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "concreteType": "Comment",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                          (v5/*: any*/),
                                                                                          (v7/*: any*/),
                                                                                          {
                                                                                            "alias": "comments",
                                                                                            "args": null,
                                                                                            "concreteType": "CommentConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "__CommentsPanel_comments_connection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                              {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "concreteType": "CommentEdge",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "edges",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                  {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Comment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                      (v5/*: any*/),
                                                                                                      (v7/*: any*/),
                                                                                                      {
                                                                                                        "alias": "comments",
                                                                                                        "args": null,
                                                                                                        "concreteType": "CommentConnection",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "__CommentsPanel_comments_connection",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                          {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "CommentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                              {
                                                                                                                "alias": null,
                                                                                                                "args": null,
                                                                                                                "concreteType": "Comment",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "node",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                  (v5/*: any*/),
                                                                                                                  (v7/*: any*/),
                                                                                                                  {
                                                                                                                    "alias": "comments",
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "CommentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "__CommentsPanel_comments_connection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                      {
                                                                                                                        "alias": null,
                                                                                                                        "args": null,
                                                                                                                        "concreteType": "CommentEdge",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "edges",
                                                                                                                        "plural": true,
                                                                                                                        "selections": [
                                                                                                                          {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "Comment",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                              (v5/*: any*/),
                                                                                                                              (v7/*: any*/),
                                                                                                                              (v9/*: any*/)
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                          },
                                                                                                                          (v10/*: any*/)
                                                                                                                        ],
                                                                                                                        "storageKey": null
                                                                                                                      },
                                                                                                                      (v11/*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                  },
                                                                                                                  (v9/*: any*/)
                                                                                                                ],
                                                                                                                "storageKey": null
                                                                                                              },
                                                                                                              (v10/*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                          },
                                                                                                          (v11/*: any*/)
                                                                                                        ],
                                                                                                        "storageKey": null
                                                                                                      },
                                                                                                      (v9/*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                  },
                                                                                                  (v10/*: any*/)
                                                                                                ],
                                                                                                "storageKey": null
                                                                                              },
                                                                                              (v11/*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                          },
                                                                                          (v9/*: any*/)
                                                                                        ],
                                                                                        "storageKey": null
                                                                                      },
                                                                                      (v10/*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                  },
                                                                                  (v11/*: any*/)
                                                                                ],
                                                                                "storageKey": null
                                                                              },
                                                                              (v9/*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                          },
                                                                          (v10/*: any*/)
                                                                        ],
                                                                        "storageKey": null
                                                                      },
                                                                      (v11/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  (v9/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v10/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v11/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v9/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v10/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v11/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v9/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v15/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "UserAvatar_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "UserAuthorName_user"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentAuthorizations",
                    "kind": "LinkedField",
                    "name": "authorizations",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "VoteButtons_votable"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Report_reportable"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReactableMeasures_reactable"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "commentable",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SubmitCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SubmitCommentPayload",
        "kind": "LinkedField",
        "name": "submitComment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CommentEdge",
            "kind": "LinkedField",
            "name": "newCommentEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v8/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": (v25/*: any*/),
                    "concreteType": "CommentConnection",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v8/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": (v25/*: any*/),
                                "concreteType": "CommentConnection",
                                "kind": "LinkedField",
                                "name": "comments",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v12/*: any*/),
                                          (v13/*: any*/),
                                          (v14/*: any*/),
                                          (v8/*: any*/),
                                          (v23/*: any*/),
                                          (v24/*: any*/),
                                          {
                                            "alias": null,
                                            "args": (v25/*: any*/),
                                            "concreteType": "CommentConnection",
                                            "kind": "LinkedField",
                                            "name": "comments",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CommentEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v5/*: any*/),
                                                      (v12/*: any*/),
                                                      (v13/*: any*/),
                                                      (v14/*: any*/),
                                                      (v8/*: any*/),
                                                      (v23/*: any*/),
                                                      (v24/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": (v25/*: any*/),
                                                        "concreteType": "CommentConnection",
                                                        "kind": "LinkedField",
                                                        "name": "comments",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Comment",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v5/*: any*/),
                                                                  (v12/*: any*/),
                                                                  (v13/*: any*/),
                                                                  (v14/*: any*/),
                                                                  (v8/*: any*/),
                                                                  (v23/*: any*/),
                                                                  (v24/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": (v25/*: any*/),
                                                                    "concreteType": "CommentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "comments",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "CommentEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                          {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Comment",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v5/*: any*/),
                                                                              (v12/*: any*/),
                                                                              (v13/*: any*/),
                                                                              (v14/*: any*/),
                                                                              (v8/*: any*/),
                                                                              (v23/*: any*/),
                                                                              (v24/*: any*/),
                                                                              {
                                                                                "alias": null,
                                                                                "args": (v25/*: any*/),
                                                                                "concreteType": "CommentConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "comments",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                      {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "concreteType": "Comment",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                          (v5/*: any*/),
                                                                                          (v12/*: any*/),
                                                                                          (v13/*: any*/),
                                                                                          (v14/*: any*/),
                                                                                          (v8/*: any*/),
                                                                                          (v23/*: any*/),
                                                                                          (v24/*: any*/),
                                                                                          {
                                                                                            "alias": null,
                                                                                            "args": (v25/*: any*/),
                                                                                            "concreteType": "CommentConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "comments",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                              {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "concreteType": "CommentEdge",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "edges",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                  {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Comment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                      (v5/*: any*/),
                                                                                                      (v12/*: any*/),
                                                                                                      (v13/*: any*/),
                                                                                                      (v14/*: any*/),
                                                                                                      (v8/*: any*/),
                                                                                                      (v23/*: any*/),
                                                                                                      (v24/*: any*/),
                                                                                                      {
                                                                                                        "alias": null,
                                                                                                        "args": (v25/*: any*/),
                                                                                                        "concreteType": "CommentConnection",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "comments",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                          {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "CommentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                              {
                                                                                                                "alias": null,
                                                                                                                "args": null,
                                                                                                                "concreteType": "Comment",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "node",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                  (v5/*: any*/),
                                                                                                                  (v12/*: any*/),
                                                                                                                  (v13/*: any*/),
                                                                                                                  (v14/*: any*/),
                                                                                                                  (v8/*: any*/),
                                                                                                                  (v23/*: any*/),
                                                                                                                  (v24/*: any*/),
                                                                                                                  {
                                                                                                                    "alias": null,
                                                                                                                    "args": (v25/*: any*/),
                                                                                                                    "concreteType": "CommentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "comments",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                      {
                                                                                                                        "alias": null,
                                                                                                                        "args": null,
                                                                                                                        "concreteType": "CommentEdge",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "edges",
                                                                                                                        "plural": true,
                                                                                                                        "selections": [
                                                                                                                          {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "Comment",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                              (v5/*: any*/),
                                                                                                                              (v12/*: any*/),
                                                                                                                              (v13/*: any*/),
                                                                                                                              (v14/*: any*/),
                                                                                                                              (v8/*: any*/),
                                                                                                                              (v23/*: any*/),
                                                                                                                              (v24/*: any*/),
                                                                                                                              (v9/*: any*/),
                                                                                                                              (v31/*: any*/),
                                                                                                                              (v32/*: any*/),
                                                                                                                              (v33/*: any*/)
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                          },
                                                                                                                          (v10/*: any*/)
                                                                                                                        ],
                                                                                                                        "storageKey": null
                                                                                                                      },
                                                                                                                      (v11/*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": "comments(first:2147483647)"
                                                                                                                  },
                                                                                                                  (v34/*: any*/),
                                                                                                                  (v9/*: any*/),
                                                                                                                  (v31/*: any*/),
                                                                                                                  (v32/*: any*/),
                                                                                                                  (v33/*: any*/)
                                                                                                                ],
                                                                                                                "storageKey": null
                                                                                                              },
                                                                                                              (v10/*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                          },
                                                                                                          (v11/*: any*/)
                                                                                                        ],
                                                                                                        "storageKey": "comments(first:2147483647)"
                                                                                                      },
                                                                                                      (v34/*: any*/),
                                                                                                      (v9/*: any*/),
                                                                                                      (v31/*: any*/),
                                                                                                      (v32/*: any*/),
                                                                                                      (v33/*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                  },
                                                                                                  (v10/*: any*/)
                                                                                                ],
                                                                                                "storageKey": null
                                                                                              },
                                                                                              (v11/*: any*/)
                                                                                            ],
                                                                                            "storageKey": "comments(first:2147483647)"
                                                                                          },
                                                                                          (v34/*: any*/),
                                                                                          (v9/*: any*/),
                                                                                          (v31/*: any*/),
                                                                                          (v32/*: any*/),
                                                                                          (v33/*: any*/)
                                                                                        ],
                                                                                        "storageKey": null
                                                                                      },
                                                                                      (v10/*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                  },
                                                                                  (v11/*: any*/)
                                                                                ],
                                                                                "storageKey": "comments(first:2147483647)"
                                                                              },
                                                                              (v34/*: any*/),
                                                                              (v9/*: any*/),
                                                                              (v31/*: any*/),
                                                                              (v32/*: any*/),
                                                                              (v33/*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                          },
                                                                          (v10/*: any*/)
                                                                        ],
                                                                        "storageKey": null
                                                                      },
                                                                      (v11/*: any*/)
                                                                    ],
                                                                    "storageKey": "comments(first:2147483647)"
                                                                  },
                                                                  (v34/*: any*/),
                                                                  (v9/*: any*/),
                                                                  (v31/*: any*/),
                                                                  (v32/*: any*/),
                                                                  (v33/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v10/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v11/*: any*/)
                                                        ],
                                                        "storageKey": "comments(first:2147483647)"
                                                      },
                                                      (v34/*: any*/),
                                                      (v9/*: any*/),
                                                      (v31/*: any*/),
                                                      (v32/*: any*/),
                                                      (v33/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v10/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v11/*: any*/)
                                            ],
                                            "storageKey": "comments(first:2147483647)"
                                          },
                                          (v34/*: any*/),
                                          (v9/*: any*/),
                                          (v31/*: any*/),
                                          (v32/*: any*/),
                                          (v33/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v11/*: any*/)
                                ],
                                "storageKey": "comments(first:2147483647)"
                              },
                              (v34/*: any*/),
                              (v9/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/),
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": "comments(first:2147483647)"
                  },
                  (v34/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "commentable",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v14/*: any*/),
              (v22/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fe9c12459ec06af3fd0b65bf1222173a",
    "id": null,
    "metadata": {},
    "name": "SubmitCommentMutation",
    "operationKind": "mutation",
    "text": "mutation SubmitCommentMutation(\n  $commentableId: ID!\n  $content: String\n  $anonymous: Boolean\n) {\n  submitComment(commentableId: $commentableId, content: $content, anonymous: $anonymous) {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n    newCommentEdge {\n      node {\n        id\n        title\n        ...CommentCard_comment\n        isFromAdminUser\n        comments(first: 2147483647) {\n          edges {\n            node {\n              id\n              ...CommentCard_comment\n              comments(first: 2147483647) {\n                edges {\n                  node {\n                    id\n                    ...CommentCard_comment\n                    comments(first: 2147483647) {\n                      edges {\n                        node {\n                          id\n                          ...CommentCard_comment\n                          comments(first: 2147483647) {\n                            edges {\n                              node {\n                                id\n                                ...CommentCard_comment\n                                comments(first: 2147483647) {\n                                  edges {\n                                    node {\n                                      id\n                                      ...CommentCard_comment\n                                      comments(first: 2147483647) {\n                                        edges {\n                                          node {\n                                            id\n                                            ...CommentCard_comment\n                                            comments(first: 2147483647) {\n                                              edges {\n                                                node {\n                                                  id\n                                                  ...CommentCard_comment\n                                                  comments(first: 2147483647) {\n                                                    edges {\n                                                      node {\n                                                        id\n                                                        ...CommentCard_comment\n                                                        comments(first: 2147483647) {\n                                                          edges {\n                                                            node {\n                                                              id\n                                                              ...CommentCard_comment\n                                                              __typename\n                                                            }\n                                                            cursor\n                                                          }\n                                                          pageInfo {\n                                                            endCursor\n                                                            hasNextPage\n                                                          }\n                                                        }\n                                                        __typename\n                                                      }\n                                                      cursor\n                                                    }\n                                                    pageInfo {\n                                                      endCursor\n                                                      hasNextPage\n                                                    }\n                                                  }\n                                                  __typename\n                                                }\n                                                cursor\n                                              }\n                                              pageInfo {\n                                                endCursor\n                                                hasNextPage\n                                              }\n                                            }\n                                            __typename\n                                          }\n                                          cursor\n                                        }\n                                        pageInfo {\n                                          endCursor\n                                          hasNextPage\n                                        }\n                                      }\n                                      __typename\n                                    }\n                                    cursor\n                                  }\n                                  pageInfo {\n                                    endCursor\n                                    hasNextPage\n                                  }\n                                }\n                                __typename\n                              }\n                              cursor\n                            }\n                            pageInfo {\n                              endCursor\n                              hasNextPage\n                            }\n                          }\n                          __typename\n                        }\n                        cursor\n                      }\n                      pageInfo {\n                        endCursor\n                        hasNextPage\n                      }\n                    }\n                    __typename\n                  }\n                  cursor\n                }\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        content\n        createdAt\n        commentsCount\n        author {\n          __typename\n          name\n          ...UserAvatar_user\n          ...UserAuthorName_user\n          id\n        }\n        authorizations {\n          requiresModeration\n          submitComment\n          commentsDisplayAuthorized\n          votesDisplayAuthorized\n          votesSubmissionAuthorized\n          id\n        }\n        ...VoteButtons_votable\n        ...Report_reportable\n        ...ReactableMeasures_reactable\n      }\n    }\n    finalizeUrl\n    commentable {\n      __typename\n      commentsCount\n      totalCommentsCount\n      id\n    }\n  }\n}\n\nfragment CommentCard_comment on Comment {\n  id\n  content\n  createdAt\n  commentsCount\n  isFromAdminUser\n  author {\n    __typename\n    name\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    id\n  }\n  authorizations {\n    requiresModeration\n    submitComment\n    commentsDisplayAuthorized\n    votesDisplayAuthorized\n    votesSubmissionAuthorized\n    id\n  }\n  ...VoteButtons_votable\n  ...Report_reportable\n  ...ReactableMeasures_reactable\n}\n\nfragment DownVoteButton_votable on Votable {\n  __isVotable: __typename\n  id\n  currentViewerVote\n  singleVoteMode\n  votesMode\n  authorizations {\n    __typename\n    submitVote\n    unauthorizedMessages {\n      __typename\n      submitVote\n      id\n    }\n    id\n  }\n  votes {\n    id\n    down\n  }\n  ...useVoteButtonsLabel_votable\n  ...VoteButton_votable\n}\n\nfragment ReactableMeasures_reactable on Reactable {\n  __isReactable: __typename\n  totalCommentsCount\n  votesMode\n  authorizations {\n    __typename\n    votesDisplayAuthorized\n    votesDownAuthorized\n    commentsDisplayAuthorized\n    id\n  }\n  votes {\n    up\n    down\n    id\n  }\n}\n\nfragment Report_reportable on Reportable {\n  __isReportable: __typename\n  id\n}\n\nfragment UpVoteButton_votable on Votable {\n  __isVotable: __typename\n  id\n  currentViewerVote\n  singleVoteMode\n  votesMode\n  authorizations {\n    __typename\n    submitVote\n    unauthorizedMessages {\n      __typename\n      submitVote\n      id\n    }\n    id\n  }\n  votes {\n    id\n    up\n  }\n  ...useVoteButtonsLabel_votable\n  ...VoteButton_votable\n}\n\nfragment UserAuthorName_user on Viewer {\n  __isViewer: __typename\n  name\n  statusName\n  isAdmin\n  additionalViewerFields\n}\n\nfragment UserAvatar_user on Viewer {\n  __isViewer: __typename\n  name\n  avatarUrl\n}\n\nfragment VoteButton_votable on Votable {\n  __isVotable: __typename\n  remainingVotesCount\n  limitedVotesPerUser\n}\n\nfragment VoteButtons_votable on Votable {\n  __isVotable: __typename\n  authorizations {\n    __typename\n    votesSubmissionAuthorized\n    votesDownAuthorized\n    id\n  }\n  ...UpVoteButton_votable\n  ...DownVoteButton_votable\n}\n\nfragment useVoteButtonsLabel_votable on Votable {\n  __isVotable: __typename\n  votesMode\n  currentViewerVote\n  singleVoteMode\n  ...VoteButton_votable\n}\n"
  }
};
})();

node.hash = "05d0012e2971ad1b7f34144c71d8afc1";

module.exports = node;
